module.exports = __webpack_public_path__ + "static/media/vacancy-form-image.6fe5cd03.svg";